import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('b4p_theme') || 'auto';
    });

    useEffect(() => {
        localStorage.setItem('b4p_theme', theme);
        const root = document.documentElement;

        // Remove all theme classes first
        root.classList.remove('light', 'dark', 'high-contrast');

        if (theme === 'high-contrast') {
            root.classList.add('high-contrast');
        } else if (theme === 'auto') {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            root.classList.toggle('light', !prefersDark);
            root.classList.toggle('dark', prefersDark);
        } else {
            root.classList.toggle('light', theme === 'light');
            root.classList.toggle('dark', theme === 'dark');
        }
    }, [theme]);

    // Listen for system theme changes when in auto mode
    useEffect(() => {
        if (theme !== 'auto') return;
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => {
            document.documentElement.classList.remove('light', 'dark');
            document.documentElement.classList.toggle('light', !e.matches);
            document.documentElement.classList.toggle('dark', e.matches);
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
